module.exports = __webpack_public_path__ + "img/qrcode2.fa3d686a.png";